(function () {
  function applyTitleGradient() {
    const wrap = document.getElementById('productTitleWrap');
    if (!wrap) return;

    const title = wrap.innerText.toLowerCase();

    wrap.classList.remove(
      'title-pride',
      'title-galactic',
      'title-gal-blue',
      'title-gal-red',
      'title-gal-green',
      'title-shimmer',
      'title-glow',
      'title-holo'
    );

    if (title.includes('pride')) {
      wrap.classList.add('title-pride');
      return;
    }

    if (title.includes('reflekt')) {
      wrap.classList.add('title-glow');
      return;
    }

    if (title.includes('glitter')) {
      wrap.classList.add('title-shimmer');
      return;
    }

    if (title.includes('holo') || title.includes('holographic')) {
      wrap.classList.add('title-holo');
      return;
    }

    if (title.includes('galactic')) {
      if (title.includes('blue')) {
        wrap.classList.add('title-gal-blue');
        return;
      }
      if (title.includes('red')) {
        wrap.classList.add('title-gal-red');
        return;
      }
      if (title.includes('green')) {
        wrap.classList.add('title-gal-green');
        return;
      }
      wrap.classList.add('title-galactic');
    }
  }

  document.addEventListener('DOMContentLoaded', applyTitleGradient);
})();